"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FragmentMetaType = void 0;
var FragmentMetaType;
exports.FragmentMetaType = FragmentMetaType;

(function (FragmentMetaType) {
  FragmentMetaType["PARTNER_BUTTON"] = "PARTNER_BUTTON";
})(FragmentMetaType || (exports.FragmentMetaType = FragmentMetaType = {}));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9jb3JlL0xheW91dC9GcmFnbWVudE1ldGEvRnJhZ21lbnRNZXRhVHlwZS50cyJdLCJuYW1lcyI6WyJGcmFnbWVudE1ldGFUeXBlIl0sIm1hcHBpbmdzIjoiOzs7Ozs7SUFBWUEsZ0I7OztXQUFBQSxnQjtBQUFBQSxFQUFBQSxnQjtHQUFBQSxnQixnQ0FBQUEsZ0IiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZW51bSBGcmFnbWVudE1ldGFUeXBlIHtcbiAgICBQQVJUTkVSX0JVVFRPTiA9ICdQQVJUTkVSX0JVVFRPTicsXG59XG4iXX0=